import { OfferPremium } from './offer-premium.model';
import { AgreementModel } from './../agreement.model';
import { OfferCoverage } from './offer-coverage.model';
import { OfferCounter } from './offer-counter.model';
import { OfferInsuranceResource } from './offer-insurance-resource.model';
import {OfferModification} from './offer-modification.model';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

export class Offer {
  id: string; // Identyfikator oferty
  simpleId: string; // Przyjazny dla uzytkownika UUID
  counter: OfferCounter; // Obiekt zliczający oferty, które dotyczą tej samej dziedziny
  createData: string; // Moment utworzenia oferty
  expiryDate: string; // Moment kiedy oferta wygasa
  coverages: OfferCoverage[]; // Lista obiektów zawierających covery dla danego pakietu.
  agreements: AgreementModel[]; // Lista przechowująca zgody
  premiums: OfferPremium[]; // Obiekt przechowujący dane składki
  insuranceResource: OfferInsuranceResource; // Obiekt przechowujący dane dotyczące zasobów towarzystwa
  packageName: string; // nazwa pakietu wykorzystywanego do parowania oferty
  maxDaysToStartInsurance: number; // maksymalna liczba dni dzielących datę startu ubezpieczenia od dzisiaj
  modifications: OfferModification[];
  paymentMethods?: string[];

  static getOfferPrice(offer: Offer, premiumId?: string): number {
      if (isNotNullOrUndefined(premiumId)) {
          const premium = offer.premiums.find(offerPremium => offerPremium.id === premiumId);
          if (isNotNullOrUndefined(premium)) {
              return premium.amount.amount;
          }
      }
      return this.findPremiumWithOneInstalment(offer).amount.amount;
  }

  static getOfferLowestPrice(offer: Offer): number {
      const premiumAmount = this.findPremiumWithOneInstalment(offer).amount;
      if (isNotNullOrUndefined(premiumAmount.amountWithDiscount) && !isNaN(premiumAmount.amountWithDiscount) && premiumAmount.amountWithDiscount > 0) {
          return Math.min(premiumAmount.amountWithDiscount, premiumAmount.amount);
      }
      return premiumAmount.amount;
  }

  static findPremiumElement(offer: Offer): OfferPremium {
    // sort desc premiums by instalments length and return premium with largest instalments count
    return offer.premiums.sort((a, b) => (a.instalments.length > b.instalments.length) ? -1 : 1)[0];
  }

  static findPremiumWithOneInstalment(offer: Offer): OfferPremium {
    // sort asc premiums by instalments length and return premium with largest instalments count
    return offer.premiums.sort((a, b) => (a.instalments.length < b.instalments.length) ? -1 : 1)[0];
  }

  constructor({
                id,
                simpleId,
                counter,
                createData,
                expiryDate,
                coverages,
                agreements,
                premiums,
                insuranceResource,
              }) {
    this.id = id;
    this.simpleId = simpleId;
    this.counter = counter;
    this.createData = createData;
    this.expiryDate = expiryDate;
    this.coverages = coverages;
    this.agreements = agreements;
    this.premiums = premiums;
    this.insuranceResource = insuranceResource;
  }
}
